import { render, staticRenderFns } from "./projectProgressChart.vue?vue&type=template&id=2d48aa61&scoped=true&"
import script from "./projectProgressChart.vue?vue&type=script&lang=js&"
export * from "./projectProgressChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d48aa61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d48aa61')) {
      api.createRecord('2d48aa61', component.options)
    } else {
      api.reload('2d48aa61', component.options)
    }
    module.hot.accept("./projectProgressChart.vue?vue&type=template&id=2d48aa61&scoped=true&", function () {
      api.rerender('2d48aa61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newDashboard/components/chart/projectProgressChart.vue"
export default component.exports